import React from "react";

const SecondaryHeading = ({ variant, children, className = "" }) => {
  return (
    <>
    
      {/* o	Usage: Subheadings within content sections. */}
      {variant === "MainParagraphHeading" && (
        <p
          className={`
          ${className} body-heading font-inter`}
        >
          {children}
        </p>
      )}

      {variant === "BodyCompactHeading" && (
        <p
          className={`
          ${className} body-standard font-inter font-semibold`}
        >
          {children}
        </p>
      )}

      {variant === "BodyDenseHeading" && (
        <p
          className={`
          ${className} font-inter font-semibold`}
        >
          {children}
        </p>
      )}

      {variant === "BodySmallHeading" && (
        <p
          className={`
          ${className} body-small font-inter font-semibold`}
        >
          {children}
        </p>
      )}

      {variant === "BodyMetaHeading" && (
        <p
          className={`
          ${className} font-inter font-semibold`}
        >
          {children}
        </p>
      )}

      {/* o	Usage: Default style for footer. */}
      {variant === "FooterHeading" && (
        <p
          className={`
          ${className} footer-title font-inter capitalize`}
        >
          {children}
        </p>
      )}
    </>
  );
};
export default SecondaryHeading;
